// extracted by mini-css-extract-plugin
export default {"primary":"Animation_primary__wGPhp","secondary":"Animation_secondary__oQrio","circle":"Animation_circle__3w5Lf"};